import { format } from "date-fns";
import * as Yup from "yup";

export const HomeBookingSchema = Yup.object({
  first_name: Yup.string().trim().required("The first name field is required."),
  last_name: Yup.string().trim().required("The last name field is required."),
  sex: Yup.string().trim().oneOf(['Male','Female','Non-binary','Prefer not to say'],'That is not a available option for that').required('The sex field is required'),
  birthdate: Yup.date().required('The birthdate field is required').test('birthdate', 'Age should be above 1 yr old', (value) => {
    return new Date().getFullYear() - new Date(value).getFullYear() > 1;
  }),
  email: Yup.string().email('Email must be valid').trim().required('The email is required') ,
  contact_no: Yup.number().required('The contact number field is required').test('phl_contactNo', 'Please check the length of the contact number', (value) => {
    const regex = /^\d{10}$/;
    return regex.test(value);
  }),
  citizenship: Yup.string().trim().required('The citizenship field is required'),
  emergency_person_first_name: Yup.string().trim().required("The emergency person first name field is required."),
  emergency_person_last_name: Yup.string().trim().required("The emergency person last name field is required."),
  emergency_person_email: Yup.string().email().trim().required("The emergency person last name field is required."),
  emergency_person_contact_no: Yup.number().required('The emergency person contact number field is required').test('phl_contactNo', 'Please check the length of the contact number', (value) => {
    const regex = /^\d{10}$/;
    return regex.test(value);
  }),
});

export const ConfirmBookingSchema = Yup.object({
  appointment_location: Yup.string()
      .trim()
      .required('The appointment location field is required.'),
  total_fee: Yup.number().required('The total fee field is required').min(1,'The total fee must be greater than 1'),
  remarks: Yup.string()
      .trim()
      .nullable()
  
})
export const ServerHomeBookingSchema = Yup.object({
  first_name: Yup.string().trim().optional(),
  last_name: Yup.string().trim().optional(),
  sex: Yup.string().trim().oneOf(['Male','Female','Non-binary','Prefer not to say'],'That is not a available option for that').optional(),
  birthdate: Yup.date().optional(),
  email: Yup.string().email('Email must be valid').trim().optional() ,
  contact_no: Yup.number().optional(),
  emergency_person_first_name: Yup.string().trim().optional(),
  emergency_person_last_name: Yup.string().trim().optional(),
  emergency_person_email: Yup.string().email().trim().optional(),
  emergency_person_contact_no: Yup.number().optional(),
});

export default HomeBookingSchema
